module.exports = __webpack_public_path__ + "static/media/wirecard.971fb905.svg";